<script setup lang="ts">
type Props = {
  visibilityOffset?: number;
  staticHeaderClass?: string;
  stickyDisabled?: boolean;
};

const { visibilityOffset = 200, stickyDisabled = true } = defineProps<Props>();

const staticHeaderRef = useTemplateRef("staticHeaderRef");
const { top } = useElementBounding(staticHeaderRef);
const staticHeaderVisible = computed(() => top.value > -visibilityOffset);
</script>

<template>
  <ClientOnly v-if="!stickyDisabled">
    <Teleport to="#header-teleports">
      <div
        data-test="sticky-header"
        data-cy="sticky-header"
        :aria-hidden="staticHeaderVisible"
        class="w-full bottom-0 transition-all"
        :class="{
          block: !staticHeaderVisible,
          hidden: staticHeaderVisible,
        }"
      >
        <slot />
      </div>
    </Teleport>
  </ClientOnly>
  <div
    :id="STATIC_HEADER_ID"
    ref="staticHeaderRef"
    data-cy="static-header"
    :class="staticHeaderClass"
  >
    <slot />
  </div>
</template>
